import EA from '../helpers/init';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.animFadeBottom = ($this) => {
    const offset = $this.getAttribute('data-offset');
    const fadeInEls = $this.querySelectorAll('.fade-in-bot-anim');

    let stagger = 0.35;
    const minStagger = 0.17;
    const childrenCount = fadeInEls.length;
    const decrement = -0.03;


    gsap.config({
        nullTargetWarn: false
    });

    if(childrenCount > 4) {
        for(let i = 3; i < childrenCount; i++) {
            stagger += decrement;
            stagger = Math.max(minStagger, stagger);
        }
    }


    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: $this,
            start: `${offset} 70%`,
            end: 'bottom 50%',
            // markers: true,
        },
    });
    tl
        .from(fadeInEls, {
            y: 70,
            duration: 0.75,
            alpha: 0,
            stagger: stagger,
            ease: 'power3.out',
            clearProps: 'transform,opacity',
        });
};
